import {Select} from 'antd';
import CaseInput from 'components/formItems/CaseInput';
import moment from 'moment';
import {useCallback, useEffect, useState} from 'react';
import SERVICES from 'services';
import './Timetable.less';

const timetableData = [
	{
		day: 'Երկուշաբթի',
		date: '15.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ա․ Դարբինյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '310',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '309',
				lecturer: 'Մ․ Խաչատրյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ռուսաց լեզու',
				type: 'CM',
				group: '108A',
				classroom: '451',
				lecturer: 'Դ․ Հովհաննիսյան',
				present: false
			}
		]
	},
	{
		day: 'Երեքշաբթի',
		date: '16.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'ԷՀՄ Ճարտարագիտություն և Ասամբլերի լեզու',
				type: 'CM',
				group: '108A',
				classroom: '300',
				lecturer: 'Հ․ Սթեփանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '325',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ալգորիթմներ և ալգորիթմական լեզուներ (C լեզու)',
				type: 'CM',
				group: '108A',
				classroom: '315',
				lecturer: 'Ա․ Հովակիմյան',
				present: true
			}
		]
	},
	{
		day: 'Ձորեքշաբթի',
		date: '17.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ա․ Դարբինյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '310',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '309',
				lecturer: 'Մ․ Խաչատրյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ռուսաց լեզու',
				type: 'CM',
				group: '108A',
				classroom: '451',
				lecturer: 'Դ․ Հովհաննիսյան',
				present: false
			}
		]
	},
	{
		day: 'Հինգշաբթի',
		date: '18.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'ԷՀՄ Ճարտարագիտություն և Ասամբլերի լեզու',
				type: 'CM',
				group: '108A',
				classroom: '300',
				lecturer: 'Հ․ Սթեփանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '325',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ալգորիթմներ և ալգորիթմական լեզուներ (C լեզու)',
				type: 'CM',
				group: '108A',
				classroom: '315',
				lecturer: 'Ա․ Հովակիմյան',
				present: true
			}
		]
	},
	{
		day: 'Ուրբաթ',
		date: '19.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ա․ Դարբինյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '310',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '309',
				lecturer: 'Մ․ Խաչատրյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ռուսաց լեզու',
				type: 'CM',
				group: '108A',
				classroom: '451',
				lecturer: 'Դ․ Հովհաննիսյան',
				present: false
			}
		]
	},
	{
		day: 'Շաբաթ',
		date: '19.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'ԷՀՄ Ճարտարագիտություն և Ասամբլերի լեզու',
				type: 'CM',
				group: '108A',
				classroom: '300',
				lecturer: 'Հ․ Սթեփանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '325',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ալգորիթմներ և ալգորիթմական լեզուներ (C լեզու)',
				type: 'CM',
				group: '108A',
				classroom: '315',
				lecturer: 'Ա․ Հովակիմյան',
				present: true
			}
		]
	},
	{
		day: 'Երկուշաբթի',
		date: '15.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ա․ Դարբինյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '310',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Մաթեմատիկական Անալիզ',
				type: 'CM',
				group: '108A',
				classroom: '309',
				lecturer: 'Մ․ Խաչատրյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ռուսաց լեզու',
				type: 'CM',
				group: '108A',
				classroom: '451',
				lecturer: 'Դ․ Հովհաննիսյան',
				present: false
			}
		]
	},
	{
		day: 'Երեքշաբթր',
		date: '16.08.2022',
		subjects: [
			{
				time: '9:00 - 10:20',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '313',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '10:30 - 12:15',
				name: 'ԷՀՄ Ճարտարագիտություն և Ասամբլերի լեզու',
				type: 'CM',
				group: '108A',
				classroom: '300',
				lecturer: 'Հ․ Սթեփանյան',
				present: true
			},
			{
				time: '12:50 - 14:10',
				name: 'Հանրահաշիվ և Երկրաչափություն',
				type: 'CM',
				group: '108A',
				classroom: '325',
				lecturer: 'Ն․ Միրզախանյան',
				present: true
			},
			{
				time: '14:20 - 15:40',
				name: 'Ալգորիթմներ և ալգորիթմական լեզուներ (C լեզու)',
				type: 'CM',
				classroom: '315',
				lecturer: 'Ա․ Հովակիմյան',
				present: null
			}
		]
	}
];

const weekDays = {
	1: 'Երկուշաբթի',
	2: 'Երեքշաբթրի',
	3: 'Չորեքշաբթի',
	4: 'Հինգշաբթի',
	5: 'Ուրբաթ',
	6: 'Շաբաթ',
	7: 'Կիրակի'
};

const Timetable = () => {
	const [lessonsWeeks, setLessonsWeeks] = useState<any[]>([]);
	const [currentWeekID, setCurrentWeekID] = useState<number | undefined>(undefined);
	const [weekID, setWeekID] = useState<number | null>(null);
	const [data, setData] = useState<any[]>([]);

	const getSchedulData = useCallback(
		(weekID: number) => {
			SERVICES.USER.getSchedule(weekID).then(res => {
				const data: typeof timetableData = [];

				res.data.data.forEach((el: any) => {
					const dow = weekDays[moment(el.lessonDate).weekday() as keyof typeof weekDays];
					const existenceID = data.findIndex(i => i.day === dow);
					if (existenceID !== -1) {
						data[existenceID].subjects.push({
							name: el.subjectName,
							time: el.timeName,
							type: el.lessonTypeName,
							group: el.groupName || el.flowName,
							classroom: el.classroomName,
							lecturer: el.lecturerName,
							present: el.present || null
						});
					} else {
						data.push({
							date: moment(el.lessonDate).format('DD.MM.YYYY'),
							day: dow,
							subjects: [
								{
									name: el.subjectName,
									time: el.timeName,
									type: el.lessonTypeName,
									group: el.groupName || el.flowName,
									classroom: el.classroomName,
									lecturer: el.lecturerName,
									present: el.present || null
								}
							]
						});
					}
				});

				setData(data.sort((day1, day2) => moment(day1.date).diff(day2.date)));
			});
		},
		[weekID]
	);

	useEffect(() => {
		if (weekID !== null) {
			getSchedulData(weekID);
		} else {
			if (currentWeekID !== undefined) {
				getSchedulData(currentWeekID);
			}
		}
	}, [weekID, currentWeekID]);

	useEffect(() => {
		SERVICES.USER.getLessonsWeek().then(res => {
			setCurrentWeekID(
				(
					res.data.find((i: any) => {
						if (
							moment(i.weekStartDate).diff(moment(), 'day') <= 0 &&
							moment(i.weekEndDate).diff(moment(), 'day') >= 0
						) {
							return i;
						}
					}) || res.data[0]
				).id
			);

			setLessonsWeeks(
				res.data
					.sort((day1: any, day2: any) => moment(day1.weekStartDate).diff(moment(day2.weekEndDate)))
					.map((i: any) => ({
						value: i.id,
						label: `${moment(i.weekStartDate).format('DD/MM/YYYY')} - ${moment(
							i.weekEndDate
						).format('DD/MM/YYYY')}`
					}))
			);
		});
	}, []);

	return (
		<div className="timetable-wrapper">
			<Select
				showSearch
				filterOption={(input, option: any) =>
					option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
				}
				options={lessonsWeeks}
				value={weekID || currentWeekID}
				onChange={value => setWeekID(value)}
				style={{width: 300}}
				placeholder={'Շաբաթ'}
				className="select-filter"
			/>
			{(weekID || currentWeekID) && (
				<div className="timetable">
					<div className="timetable-header">
						<div className="day-col flex-center">Օր</div>
						<div className="hour-col flex-center">Ժամ</div>
						<div className="subject-col flex-center">Առարկա</div>
						<div className="type-col flex-center">Տեսակ</div>
						<div className="group-col flex-center">Խումբ / Հոսք</div>
						<div className="classroom-col flex-center">Լսարան</div>
						<div className="lecturer-col flex-center">Դասախոս</div>
						<div className="present-col flex-center">Ն/Բ</div>
					</div>
					<div className="timetable-content">
						{data.map((day, idx) => (
							<div className="day" key={idx}>
								<div className="day-col day-col-rotated">
									<span>{day.day}</span>
									<span>({day.date})</span>
								</div>
								<div className="hour-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.time}
										</div>
									))}
								</div>
								<div className="subject-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.name}
										</div>
									))}
								</div>
								<div className="type-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.type}
										</div>
									))}
								</div>
								<div className="group-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.group}
										</div>
									))}
								</div>
								<div className="classroom-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.classroom}
										</div>
									))}
								</div>
								<div className="lecturer-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div className="cell" key={idx}>
											{subject.lecturer}
										</div>
									))}
								</div>
								<div className="present-col">
									{day.subjects.map((subject: any, idx: number) => (
										<div
											className={`cell ${
												subject.present !== null
													? subject.present
														? 'light-green'
														: 'light-red'
													: 'light-grey'
											}`}
											key={idx}>
											{subject.present !== null ? subject.present : 'Կայացած չէ'}
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default Timetable;
